import "./Presentation.css";

const Presentation = () => {
    return (
        <div id="presentation">
            <div className="presentationItems">
                {
                //<h1>Net Viet</h1>
                }
                <div className="content">
                    <h1>BIENVENUE CHEZ NET VIET</h1>
                    <button><a href="/carte">Découvrir le menu</a></button>
                </div>
            </div>
        </div>
    );
};

export default Presentation;